import clsx from 'clsx';
import React, { FC } from 'react';
import ReactMarkdown from 'react-markdown';
import useFirebaseStorage from '../hooks/useFirebaseStorage';
import Image from '../lib/components/Image';

interface Props {
  source?: string;
  className?: string;
}

const Markdown: FC<Props> = ({ source, className }) => {
  const { getURL } = useFirebaseStorage();
  return (
    <div className={clsx('markdown-body', className)}>
      <ReactMarkdown
        source={source}
        transformImageUri={getURL}
        // eslint-disable-next-line react/jsx-props-no-spreading
        renderers={{ image: (props): JSX.Element => <Image {...props} /> }}
      />
    </div>
  );
};

export default Markdown;
